import { useState } from 'react'
import { resolveVisibility } from "../../../../common/model/condition/evaluate"
import styled from 'styled-components'
import { FormGroup } from '../form/FormComponents'
import useTranslation from '../../hooks/useTranslation'
import DocumentPickerDrawer from '../documents/DocumentPickerDrawer/DocumentPickerDrawer'
import { Icon_Document } from '../../styles/icons'
import { getNestedValueKey } from '../../utils/objects/nestedValue'
import * as BsIcons from 'react-icons/bs'

const DocList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.25rem;
`

const DocItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.5rem;
  border-radius: 6px;
  background: ${({ theme }) => theme.area?.highBg || '#f3f4f6'};
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.font?.label || '#374151'};

  svg { font-size: 0.9rem; flex-shrink: 0; opacity: 0.65; }
`

const DocName = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const DocType = styled.span`
  font-size: 0.72rem;
  color: ${({ theme }) => theme.font?.subtle || '#9ca3af'};
  white-space: nowrap;
`

const RemoveBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.font?.subtle || '#9ca3af'};
  flex-shrink: 0;
  line-height: 1;

  &:hover { color: ${({ theme }) => theme.color?.danger || '#ef4444'}; }
`

const AddLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem 0;
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.color?.primary || '#2563eb'};
  text-align: left;
  display: block;
  margin-top: 0.25rem;

  &:hover { text-decoration: underline; }
`

const DocumentPickerFormElem = ({ item, lineId, useStore, path = [], options }) => {
  const { t } = useTranslation()
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (resolveVisibility(item, { values: {}, context: { mode: options?.mode } }) !== 'show') return null

  const [documents, setDocuments] = useStore(s => getNestedValueKey(s, path, item.id))
  const docList = documents || []

  const handleAdd = (doc) => {
    if (docList.find(d => d.id === doc.id)) return
    const newDocs = [...docList, { id: doc.id, name: doc.name, fileTypeName: doc.fileTypeName || null }]
    setDocuments({ [item.id]: newDocs }, { path })
  }

  const handleRemove = (docId) => {
    const newDocs = docList.filter(d => d.id !== docId)
    setDocuments({ [item.id]: newDocs }, { path })
  }

  return (
    <>
      <FormGroup name='FormGroup' $margin='0'>
        {item.label && <FormGroup.Label>{t(item.label)}</FormGroup.Label>}
        <DocList>
          {docList.map(doc => (
            <DocItem key={doc.id}>
              {Icon_Document}
              <DocName>{doc.name}</DocName>
              {doc.fileTypeName && <DocType>{doc.fileTypeName}</DocType>}
              <RemoveBtn type="button" onClick={() => handleRemove(doc.id)} title={t('all.form.button.delete')}>
                <BsIcons.BsX size={16} />
              </RemoveBtn>
            </DocItem>
          ))}
        </DocList>
        <AddLink type="button" onClick={() => setDrawerOpen(true)}>
          + {t(item.addLabel || 'routingVersion.form.operation.documents.add')}
        </AddLink>
      </FormGroup>
      <DocumentPickerDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSelect={handleAdd}
        title={t(item.drawerTitle || 'routingVersion.form.operation.documents.drawer.title')}
      />
    </>
  )
}

export default DocumentPickerFormElem
